export function Time() {
  return (
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18 30C24.6274 30 30 24.6274 30 18C30 11.3726 24.6274 6 18 6C11.3726 6 6 11.3726 6 18C6 24.6274 11.3726 30 18 30ZM18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z" fill="currentColor"/>
    <path d="M18 10.5C17.1716 10.5 16.5 11.1716 16.5 12V19.5C16.5 20.3284 17.1716 21 18 21H24C24.8284 21 25.5 20.3284 25.5 19.5C25.5 18.6716 24.8284 18 24 18H19.5V12C19.5 11.1716 18.8284 10.5 18 10.5Z" fill="currentColor"/>
    </svg>
  );
}
